export const SERVER_URL = "https://do-calculate.com/api";

export const studyCalculators_Fr = [
  // EXISTING CALCULATORS
  {
    name: "Convertisseur de tableau GPA",
    link: "/calculator/fr/gpatableconverter/",
    description:
      "Ce calculateur aide à convertir le GPA cumulatif des étudiants à différentes échelles, telles que GPA, système de pourcentage, etc.",
    showMain: true,
  },
  {
    name: "Calculatrice de note universitaire internationale",
    link: "/calculator/fr/gpagrade/",
    description:
      "Ce calculateur calcule la note universitaire en fonction du système de classement international.",
    showMain: true,
  },
  {
    name: "Calculatrice GPA sur une échelle de 4,0",
    link: "/calculator/fr/gpa4/",
    description:
      "Utilisez cette calculatrice pour calculer le GPA cumulatif en fonction d'un système de classement de 4,0.",
    showMain: true,
  },
  {
    name: "Calculatrice GPA sur une échelle de 5,0",
    link: "/calculator/fr/gpa5/",
    description:
      "Ce calculateur calcule le GPA cumulatif en fonction d'un système de classement de 5,0.",
    showMain: true,
  },
  {
    name: "Convertisseur de note en pourcentage",
    link: "/calculator/fr/grade100/",
    description:
      "Ce calculateur convertit les notes du système de classement au système de pourcentage.",
    showMain: true,
  },
  {
    name: "Calculatrice de planification GPA",
    link: "/calculator/fr/gpaplanner/",
    description:
      "Utilisez cette calculatrice pour planifier votre GPA cumulatif futur en fonction des notes attendues.",
    showMain: true,
  },
  {
    name: "Conversion de note entre les échelles 100 et 4",
    link: "/calculator/fr/grade100to4/",
    description:
      "Ce calculateur aide à convertir les notes entre le système de pourcentage et l'échelle de classement de 4,0 et vice versa.",
    showMain: true,
  },

  // NEW STUDY CALCULATORS (26)
  {
    name: "Convertisseur GPA 4 à 5",
    link: "/calculator/fr/gpa4-to-5/",
    description:
      "Convertissez facilement votre GPA de l'échelle 4.0 à l'échelle 5.0.",
    showMain: true,
  },
  {
    name: "Convertisseur de tableau GPA 5",
    link: "/calculator/fr/gpa5-converter/",
    description:
      "Convertisseur pour convertir les notes au système GPA 5.0.",
    showMain: true,
  },
  {
    name: "Convertir GPA de 5 à 100 et vice versa",
    link: "/calculator/fr/grade100to5/",
    description:
      "Convertissez facilement votre GPA cumulatif entre les systèmes de 5 points et 100 points.",
    showMain: true,
  },
  {
    name: "Convertisseur GPA : Échelle 4,0 à Échelle 5,0 et vice versa",
    link: "/calculator/fr/gpa4to5/",
    description:
      "Utilisez cette calculatrice pour convertir le GPA cumulatif entre les échelles de classement de 4,0 et 5,0.",
    showMain: true,
  },
  {
    name: "Calculatrice de note d'examen",
    link: "/calculator/fr/test-grade/",
    description:
      "Calculez facilement votre score d'examen et votre note à l'aide de la calculatrice de note avancée.",
    showMain: true,
  },
  {
    name: "Calculatrice de pourcentage pondéré",
    link: "/calculator/fr/weighted-percentage-calculator/",
    description:
      "La calculatrice de pourcentage pondéré calcule le pourcentage pondéré d'un ensemble de valeurs.",
    showMain: true,
  },
  {
    name: "Conversion au système de classement britannique",
    link: "/calculator/fr/grade-to-uk/",
    description:
      "Ce calculateur convertit le GPA cumulatif au système de classement britannique.",
    showMain: true,
  },
  {
    name: "Convertir GPA universitaire au système allemand",
    link: "/calculator/fr/grade-to-german/",
    description:
      "Convertissez facilement et précisément votre GPA universitaire au système allemand.",
    showMain: true,
  },
  {
    name: "Convertir GPA universitaire au système français",
    link: "/calculator/fr/grade-to-french/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système français.",
    showMain: true,
  },
  {
    name: "Convertir GPA universitaire au système canadien",
    link: "/calculator/fr/grade-to-canada/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système canadien.",
    showMain: true,
  },
  {
    name: "Calculatrice de note GPA",
    link: "/calculator/fr/grade-gpa-calculator/",
    description:
      "La calculatrice de note GPA calcule votre GPA en fonction de vos notes.",
    showMain: true,
  },
];
